<template>
    <div class="d-flex flex-wrap negative-margin">
        <div
            v-for="(item, index) in filteredIcons"
            :key="`mpc-${index}`"
            class="mb-1"
        >
            <MapPopupIcon
                :name="item.name"
                :icon="item.icon"
                :value="item.value"
                :metric="item.metric"
                :key="`mpi-${index}`"
                v-if="index < 8"
                class="ml-3"
            ></MapPopupIcon>

            <span
                v-if="index === 8"
                @click="toggleIconContainer"
                class="see-all d-inline-block py-1 ml-2"
            >
                {{seeAllTitle}}
            </span>
        </div>

        {{/* Backdrop shown over info window */}}
        <div
            class="backdrop"
            :class="(filteredIcons.length > 8 && GET_SHOW_SENSOR_ICONS) && 'shown'"
        ></div>
        <div
            class="styled-popup d-flex align-items-center   "
            :class="(filteredIcons.length > 8 && GET_SHOW_SENSOR_ICONS) && 'shown'"
        >
            <div
                class="d-flex align-items-center px-1 styled-popup-chevron"
                @click="toggleIconContainer"
            >
                <SvgIcon name="chevron-right" direction="right"/>
            </div>
            <div class="styled-popup-inner">
                <div
                    v-for="(item, index) in filteredIcons"
                    :key="`mpc-${index}`"
                    class="ml-3 mb-1"
                >
                    <MapPopupIcon
                        :name="item.name"
                        :icon="item.icon"
                        :value="item.value"
                        :metric="item.metric"
                        :key="`mpi-${index}`"
                    ></MapPopupIcon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // vuex
    import {mapActions, mapGetters} from "vuex";
    import {GET_SHOW_SENSOR_ICONS, SET_SHOW_SENSOR_ICONS} from "../../store/actions/dashboard";
    // constants
    import {popupIcons} from "../../constants/sensors-constants";
    // components
    import MapPopupIcon from "./MapPopupIcon";
    import SvgIcon from "../shared/SvgIcon";


    export default {
        name: "MapPopupIcons",
        props: {
            data: Array,
            popupIcons
        },
        data() {
            return {
                seeAllTitle: this.$i18n.t("dashboard.infoWindow.see-all")
            }
        },
        components: {MapPopupIcon, SvgIcon},
        computed: {
            ...mapGetters([GET_SHOW_SENSOR_ICONS]),
            /**
             * Filters out complex data items
             * @returns []
             */
            filteredIcons() {
                return this.data.filter(
                    (item) => popupIcons.includes(item.name)
                )
            }
        },
        methods: {
            ...mapActions([SET_SHOW_SENSOR_ICONS]),
            toggleIconContainer() {
                this.SET_SHOW_SENSOR_ICONS(!this.GET_SHOW_SENSOR_ICONS);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import 'src/assets/scss/variables';

    .negative-margin {
        margin-left: -16px;
    }

    .styled-popup {
        position: absolute;
        right: -300px;
        bottom: 0;
        height: 100%;
        background: #fff;
        z-index: 1;
        transition: right 0.1s;
        transition-timing-function: cubic-bezier(0.1, 0.7, 1.0, 0.1);
        box-shadow: $all-sensors-container-shadow;

        &.shown {
            right: 0;
        }

        &-chevron {
            position: relative;
            z-index: 4 !important;
            height: max-content;
            padding: 3px;

            &:hover svg {
                filter: brigghtnes(2);
            }
        }

        &-inner {
            height: 100%;
            width: 100%;
            overflow: auto;
            padding: 5px 15px 5px 0;
            margin-left: -15px;
            position: relative;
            z-index: 0;
        }
    }

    .see-all {
        &:hover {
            text-decoration: underline;
        }
    }

    .backdrop {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #000;
        top: -350px;
        left: 0;
        opacity: 0;
        transition: opacity 0.07s;;
        transition-timing-function: cubic-bezier(0.1, 0.7, 1.0, 0.1);

        &.shown {
            top: 0 !important;
            opacity: 0.4;
        }
    }
</style>